<template>
    <div class="col-12">
        <div class="shop_item shop_item-show_more btn"
             @click="this.$router.push({
                name: 'ShopCategory',
                params: {
                    categoryId: item.id,
                },
                query: {
                    categoryName: categoryName
                }
             })">
            {{item.text}}
        </div>
    </div>
</template>

<script>

    export default {
        name: "ShopShowmore",
        props: {
            item: {},
            categoryName: String
        },
        computed: {

        }
    }
</script>